export default __webpack_public_path__ + "static/media/thumbs-down-red.0953ef58.svg";